module.exports = __webpack_public_path__ + "img/skill-challenges.9cd01289.jpeg";